module.exports = __webpack_public_path__ + "img/ETH.238811fc.svg";